import { useLocation } from "react-router-dom";
import { CancelRequestController } from "../../util/cancel-request-controller";
import { DatosFormInstitutoAPI } from "../../services/api/LoginInstitucional";
import { useQueryParams } from "../../hooks/useQueryParams";

/**
 * Hook encargado de gestionar el envío del formulario de acceso institucional tipo Email.
 *
 * Construye la información requerida por el servicio, determina el tipo de
 * ingreso según la ruta y los parámetros de la URL, realiza la petición a la
 * API y procesa la respuesta.
 *
 * Si la respuesta requiere validación adicional, ejecuta el callback recibido
 * para mostrar el modal correspondiente; de lo contrario, redirecciona al
 * usuario a la URL indicada por el backend.
 *
 * @param {Object} params - Parámetros de configuración del hook.
 * @param {Object} params.datosInstituto - Información de la institución utilizada para construir la petición.
 * @param {Function} params.onShowModal - Función que se ejecuta cuando debe mostrarse el modal informativo.
 *
 * @returns {Object} Objeto con las funciones necesarias para enviar el formulario.
 */
export const useInstitutionalEmailSubmit = ({
    datosInstituto,
    onShowModal
}) => {
    const location = useLocation();
    const params = useQueryParams();

    const redirect = params.get("redirectto");

    const submitForm = async (data) => {
        const abortController = new CancelRequestController();

        let tipoIngreso = "";

        if (
            location.pathname === "/institucional/formulario" &&
            params.get("access") === "app"
        ) {
            tipoIngreso = "app";
        }

        const propiedades = {
            inst: datosInstituto?.data?.nombreMostrar || "",
            tipoId: data?.tipoId || "",
            cedula: data?.documento || "",
            nombre: data?.nombreYapellido || "",
            correo: data?.emailInput || "",
            departamento: data?.departamento || "",
            tipoIngreso,
            redirect
        };

        try {
            const respuesta = await DatosFormInstitutoAPI.enviarDatos({
                abortSignal: abortController.signal,
                data: propiedades
            });

            if (respuesta.status === 0) {
                onShowModal && onShowModal();
            } else {
                window.location.href =
                    window.location.origin + respuesta.info;
            }
        } finally {
            abortController.abort();
        }
    };

    return {
        submitForm
    };
};